// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type DatevUserInfo } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetDatevUserInfo(): () => Promise<DatevUserInfo> {
  const getAPI = useGetApi();
  return useCallback(
    async () => (await getAPI()).externesysteme.getDatevUserInfo(),
    [getAPI]
  );
}
